import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getUserSingleDomains, getUserDomainPageData } from "../../../api/user/active-services/domain";
import { DISPLAY_LANG } from "../../../config";
import { errorMessage } from "../../../api/global";
import Loading from "../../../components/loading";
import axios from "../../../axios";
import "./domain-detail.css";

export default function UserDomainDetailPage() {
  const [pageData, setPageData] = useState([]);
  const [singleDomain, setSingleDomain] = useState(null);
  const [loading, setLoading] = useState(true);
  const [domainAutoRenewType, setDomainAutoRenewType] = useState(false);
  const [cursorLoading, setCursorLoading] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    loadingData();
    window.scrollTo(0, 0);
  }, [id]);

  const loadingData = async () => {
    const resDomain = await getUserSingleDomains(id);

    if (resDomain.custom_auto_renew) {
      setDomainAutoRenewType(true)
    } else {
      setDomainAutoRenewType(false)
    }

    setSingleDomain(resDomain);

    const resPageData = await getUserDomainPageData();
    setPageData(resPageData);

    setLoading(false);
  };

  if (loading) {
    return <Loading />;
  }

  const onChangeAutoRenew = async () => {
    setCursorLoading(true);

    const body = {
      order_id: singleDomain.order_id,
    };

    try {
      const res = await axios.post('domain/renew_domain', body);

      if (res.status !== 200) {
        throw new Error('An error occurred');
      }

      if (!res.data.ok) {
        alert(res.data.reseller_error.message);
        return;
      }

      loadingData();
    } catch (error) {
      console.log(error);
      alert(errorMessage[DISPLAY_LANG]);
    } finally {
      setCursorLoading(false);
    }
  };

  return (
    <div className="DomainDetails wrapper" style={{ cursor: cursorLoading ? 'wait' : 'default' }}>
      <h1 className="domainDetailHeading">{singleDomain.domain}</h1>

      <div className="domainDetailInfo">
        <div className="domain-information">
          <h2>{pageData.domain_info_title[DISPLAY_LANG]}</h2>
          <p>{pageData.domain_info_labels[DISPLAY_LANG].split('/')[0]} <b>{singleDomain.timestamp.split(' ')[0]}</b></p>
          <p>{pageData.domain_info_labels[DISPLAY_LANG].split('/')[1]} <b>{singleDomain.expiry?.split(' ')[0]}</b></p>

          <div className="flex-center auto-renew">
            {pageData.domain_info_labels[DISPLAY_LANG].split('/')[2]}

            <p className="choose-paying-way flex-center">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={domainAutoRenewType}
                  onChange={onChangeAutoRenew}
                />

                <span className="slider" style={{ cursor: cursorLoading ? 'wait' : 'pointer' }}></span>
              </label>
            </p>
          </div>
        </div>

        <div className="domain-contact-information">
          <h2>{pageData.domain_contact_title[DISPLAY_LANG]}</h2>

          <div className="domain-contact-address">
            <p>
              {singleDomain.address.address} <br />
              {singleDomain.address.city} {singleDomain.address.zip} {singleDomain.address.country}
            </p>

            <Link to={`/user/domains/${id}/edit-domain-contact-info`}>
              <img src="/images/partials/eye-solid-full.svg" alt="eye-solid-full" className="eye-solid-full" />
            </Link>
          </div>
        </div>

        <div className="domain-dns-servers">
          <h2>{pageData.domain_dns_title[DISPLAY_LANG]}</h2>

          <div className="dns-server-list">
            <div className="content">
              <p>{singleDomain.dns_list[0]}</p>
              <p>{singleDomain.dns_list[1]}</p>
            </div>

            <Link to={`/user/domains/${id}/edit-dns`}>
              <img src="/images/partials/edit.svg" alt="edit" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
